import { on } from '@ngrx/store';

import { UserPageMergeConflictDialogActions } from './user-page-merge-conflict-dialog.actions';
import { userPageMergeConflictDialogInitialState, UserPageMergeConflictDialogState } from './user-page-merge-conflict-dialog.state';

export const userPageMergeConflictDialogReducers = [
    on(
      UserPageMergeConflictDialogActions.dialogOpened,
      (state: UserPageMergeConflictDialogState, { primaryId, duplicateId, company, billingAddress }): UserPageMergeConflictDialogState => ({
            ...state,
            visible: true,
            primaryId,
            duplicateId,
            company,
            billingAddress,
            selectedCompany: 'primary',
            selectedBillingAddress: 'primary',
        }),
    ),
    on(
      UserPageMergeConflictDialogActions.companyOptionSelected,
      (state: UserPageMergeConflictDialogState, { option }): UserPageMergeConflictDialogState => ({
            ...state,
            selectedCompany: option,
        }),
    ),
    on(
      UserPageMergeConflictDialogActions.billingAddressOptionSelected,
      (state: UserPageMergeConflictDialogState, { option }): UserPageMergeConflictDialogState => ({
            ...state,
            selectedBillingAddress: option,
        }),
    ),
    on(
      UserPageMergeConflictDialogActions.cancelButtonClicked,
      (): UserPageMergeConflictDialogState => userPageMergeConflictDialogInitialState,
    ),
    on(
      UserPageMergeConflictDialogActions.mergeUsersSuccess,
      (): UserPageMergeConflictDialogState => userPageMergeConflictDialogInitialState,
    ),
];
